import styled from 'styled-components';
import { DropDownOptionsList as BaseDropDownOptionsList } from 'src/styles/dropDown.style';

export const CloseIcon = styled.div`
    position: absolute;
    right: 8px;
    top: 8px;
`;

export const ToggleIconButton = styled.button`
    position: absolute;
    right: 0;
    top: 0;
    color: ${({ theme }) => theme.colors.text.lightGrey};
    border: 0;
    border-left: 1px solid rgb(204, 204, 204);
    padding: 4px 8px;
    &:focus {
       border: 1px solid rgb(71, 140, 220);
    }
    outline:none;
`;

export const TradeNameWrapper = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 0;
`;

export const TradeNameLabel = styled.span`
    min-width: 80px;
`;

export const TradeNameContainer = styled.div`
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 30px;
    border: 1px solid ${({ theme }) => theme.colors.border.ccc};
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.background.white};
    padding: 4px 0 4px 4px;
    min-width: 250px;
    &:focus {
        border-color: ${({ theme }) => theme.colors.border.blue};
    }
`;

export const TradeNameInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TradeNameText = styled.div`
    flex: 1;
    padding-right: 24px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.2;
    min-height: 1.2em;
`;

export const ProductNameText = styled.div`
    color: ${({ theme }) => theme.colors.text.lightGrey};
    font-size: 0.9em;
    padding-right: 24px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.2;
    min-height: 1.2em;
`;

export const DropDownOptionsList = styled(BaseDropDownOptionsList)`
    position: absolute;
    top: -28px;
    left: 0;
    z-index: 1000;
    width: 580px;
`;

export const DropDownListContainer = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
`;

export const DropDownContainer = styled.div`
    position: relative;
`;
